import { useCallback } from 'react';
import { useParams } from 'react-router';
import { EmployeeService, type Employee } from 'src/api/EmployeeService';
import { invalidateEmployee, invalidateEmployees } from '@stores/employeeStore';
import { invalidateOrgEmployeeData } from '@stores/orgEmployeeStore';

type UpdateEmployeeExtId = (
    employeeId: string,
    value: string,
) => Promise<Employee | undefined>;

const useUpdateEmployeeExtId = (): {
    updateEmployeeExtId: UpdateEmployeeExtId;
} => {
    const { departmentId } = useParams<{
        departmentId: string;
    }>();

    const updateEmployeeExtId = useCallback<UpdateEmployeeExtId>(
        async (employeeId: string, value: string) => {
            if (!departmentId) {
                throw new Error(
                    'useUpdateEmployeeExtId requires a departmentId route param',
                );
            }

            const employee = await EmployeeService.updateEmployeeExtId(
                departmentId,
                employeeId,
                value,
            );

            if (!employee) {
                return undefined;
            }

            invalidateEmployee(departmentId, employeeId);
            invalidateEmployees(departmentId);
            invalidateOrgEmployeeData();

            return employee;
        },
        [departmentId],
    );

    return { updateEmployeeExtId };
};

export default useUpdateEmployeeExtId;
